<template>
	<div class="statistics-page">
		<!-- ROW 2 -->
		<div class="not-admin" v-if="$store.getters.getRole !=='admin'">
			<div class="vx-row" v-if="currentWidgets.length">
				<div
          v-for="(widget, idx) in currentWidgets"
          :key="idx"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/5"
				>
					<statistics-card-line
						hideChart
						class="mb-base"
						:icon="widget.icon"
						icon-right
						:color="widget.color"
						:statistic="widget.value"
						:statisticTitle="widget.name"
						:delimited="widget.delimited"
					/>
				</div>
				<div class="vx-col w-full mb-10">
					<div class="vx-row flex justify-end">
						<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/5">
							<vs-datepicker-range v-model="period"></vs-datepicker-range>
						</div>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="currentWidgets.length">

				<div
					v-for="(widget, widgetIndex) in currentGraphs"
          :key="widgetIndex"
					:class="{ 'sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2': currentGraphs.length % 2 === 0 || widgetIndex !== 0 }"
					class="vx-col w-full"
					style="margin-bottom: 2.2rem;"
				>
					<statistics-card-line
						:chartOptionsProp="widget.chartOptions"
						:series="widget.series"
						:statisticTitle="widget.name"
						style="width: 100%;"/>

				</div>
			</div>
		</div>

		<div class="admin" v-else>
			<div class="vx-row" v-if="currentWidgets.length || currentMultiWidgets.length">
				<div class="vx-col w-full statistics-page__widgets-col">
					<div class="vx-row">
						<div
							v-for="(widget, idx) in currentMultiWidgets"
              :key="idx"
							class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2"
						>
							<statistics-card-line
								hideChart
								class="mb-base"
								:widgets="widget.widgets"
							/>
						</div>
					</div>
				</div>
				<div
					class="vx-col w-full statistics-page__widgets-col"
				>
					<div class="vx-row">
            <div
              v-for="(widget, idx) in currentWidgets"
              :key="idx"
              class="vx-col  w-full sm:w-1/2 md:w-1/2 lg:w-1/2 "
              :class="{
                'xl:w-1/3':  $store.getters.getRole==='manager',
                'xl:w-1/5':  ($store.getters.getRole==='author'),
                'xl:w-1/2':  ($store.getters.getRole==='admin')
              }"
            >
							<statistics-card-line
								hideChart
								class="mb-base"
								icon-right
								:icon="widget.icon"
								:color="widget.color"
								:statistic="widget.value"
								:statisticTitle="widget.name"
								:delimited="widget.delimited"
							/>
						</div>
					</div>
				</div>

				<div class="vx-col w-full mb-base">
					<div class="vx-row flex justify-between">
						<div class="vx-col w-full sm:full md:w-1/2 lg:w-1xl:w-1/3 pb-8 sm:pb-0">
              <StatsButtonTabs :page.sync="page" />

              <template v-if="$store.getters.getRole ==='admin' && page === 3">
                <div class="vx-row">
                  <div
                    class="vx-col w-full mt-4"
                  >
                    <div class="vx-row">
                      <div class="vx-col refunds-widgets">
                        <statistics-card-line
                          v-for="(widget, idx) in refundsRightWidgets" 
                          :key="idx"
                          hideChart
                          class="mb-4"
                          icon-right
                          :icon="widget.icon"
                          :color="widget.color"
                          :statistic="widget.value"
                          :statisticTitle="widget.name"
                          :delimited="widget.delimited"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="$store.getters.getRole ==='admin' && page === 5">
                <div class="vx-row">
                  <div
                    class="vx-col w-full mt-4"
                  >
                    <div class="vx-row">
                      <div class="vx-col fails-widgets">
                        <statistics-card-line
                          v-for="(widget, idx) in failsRightWidgets"
                          :key="idx"
                          hideChart
                          class="mb-4"
                          icon-right
                          :icon="widget.icon"
                          :color="widget.color"
                          :statistic="widget.value"
                          :statisticTitle="widget.name"
                          :delimited="widget.delimited"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="$store.getters.getRole ==='admin' && page === 6">
                <div class="vx-col w-full leads-widgets mt-4">
                  <statistics-card-line
                    v-for="(widget, idx) in leadsWidgetsList"
                    :key="idx"
                    :icon="widget.icon"
                    :color="widget.color"
                    :statistic="widget.value"
                    :statisticTitle="widget.name"
                    :delimited="widget.delimited"
                    hideChart
                    class="mb-4"
                    icon-right
                  />
                </div>
              </template>
						</div>

						<div class="vx-col w-full sm:full md:w-1/2 lg:w-1/2 xl:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full mt-8 md:mt-0 lg:mt-0 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
										<!-- <v-select
											v-if="page === 1"
											class="w-full mr-8 bg-white "
											label="name"
											:placeholder="$t('manager')"
											:reduce="d => d.user_id"
											v-model="selectedManager"
											:options="managers"
											:clearable="false"
										/> -->

										<v-select
											v-if="showSitesSelect"
											class="w-full mr-8"
											label="name"
											:placeholder="$t('sites')"
											v-model="selectedSites"
											:options="sites"
											clearable
											multiple
										>
											<template #footer>
												<div class="d-flex justify-between w-full">
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="selectAllSites"

														class="pl-3 pr-3"
													>{{$t('all')}}</vs-button>
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="cleanSelectedSites"

														class="pl-3 pr-3"
													>{{$t('clean')}}</vs-button>
												</div>
											</template>
										</v-select>
									</div>

									<div class="vx-col w-full mt-8 md:mt-0 lg:mt-0 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
										<vs-datepicker-range
                      class="w-full"
                      v-model="period"
                    />

                    <vs-checkbox
											v-if="page === 6"
                      v-model="hideSpam"
                      :disabled="isLoading"
                      class="mt-4"
                      @change="onHideSpamChange"
                    >
                      {{ $t('ignoreSpam') }}
                    </vs-checkbox>

										<v-select
											v-if="showReasonsSelect"
											class="w-full mt-3"
											label="name"
											:placeholder="reasonsSelectPlaceholder"
											v-model="selectedReasons"
											:options="reasons"
											clearable
											multiple
										>
											<template #footer>
												<div class="d-flex justify-between w-full">
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="selectAllReasons"

														class="pl-3 pr-3"
													>{{$t('all')}}</vs-button>
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="cleanSelectedReasons"

														class="pl-3 pr-3"
													>{{$t('clean')}}</vs-button>
												</div>
											</template>
										</v-select>

                    <v-select
											v-if="showManagersSelect"
											class="w-full mt-3"
											label="name"
											:placeholder="$t('managers')"
											v-model="selectedManagers"
											:options="managers"
											clearable
											multiple
										>
											<template #footer>
												<div class="d-flex justify-between w-full">
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="selectAllManagers"

														class="pl-3 pr-3"
													>{{$t('all')}}</vs-button>
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="cleanSelectedManagers"

														class="pl-3 pr-3"
													>{{$t('clean')}}</vs-button>
												</div>
											</template>
										</v-select>

                    <v-select
											v-if="page === 7"
											class="w-full mt-3"
											label="name"
											:placeholder="$t('replyTypes')"
											v-model="selectedReplyTypes"
											:options="replyTypes"
											clearable
											multiple
										>
											<template #footer>
												<div class="d-flex justify-between w-full">
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="selectAllReplyTypes"

														class="pl-3 pr-3"
													>{{$t('all')}}</vs-button>
													<vs-button
														size="small"
														type="line"
														color="primary"
														@click="cleanSelectedReplyTypes"

														class="pl-3 pr-3"
													>{{$t('clean')}}</vs-button>
												</div>
											</template>
										</v-select>
									</div>
								</div>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="page === 0 && (adminCurrentGraphs.length || adminCurrentPieGraphs.length)"
				class="vx-row"
			>
				<!-- <div
					v-for="widget in adminCurrentPieGraphs"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
					style="margin-bottom: 2.2rem;"
				>
					<PieChartCard
						:chartOptions="chartOptions"
						:series="widget.series"
						:labels="widget.labels"
					/>
				</div> -->

				<div
					v-for="(widget, idx) in adminCurrentGraphs"
          :key="idx"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
					style="margin-bottom: 2.2rem;"
				>
					<statistics-card-line
						:chartOptionsProp="widget.chartOptions"
						:series="widget.series"
						:statisticTitle="widget.name"
					/>
				</div>
			</div>
			<div v-if="page === 1">
				<SitesStatsComponent
          :from="from"
          :to="to"
          :chart-options="chartOptions"
          :selected-sites="selectedSites"
          :filter-data-categories="filterDataCategories"
        />
			</div>

			<div
				v-if="page === 2  && $store.getters.getRole ==='admin'"
				class="vx-row"
			>
					<div class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3"
						 style="margin-bottom: 2.2rem;">
						<statistics-card-line
							:chartOptionsProp="adminCurrentManagerGraphs.chartOptions"
							:series="adminCurrentManagerGraphs.series"
							:statisticTitle="adminCurrentManagerGraphs.name"
						/>
					</div>
					<div
					    class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
						style="margin-bottom: 2.2rem;"
					>
						<div class="vx-row">
								<statistics-card-line
                  v-for="(widget, idx) in managersRightWidgets"
                  :key="idx"
									hideChart
									class="mb-base"
									icon-right
									:icon="widget.icon"
									:color="widget.color"
									:statistic="widget.value"
									:statisticTitle="widget.name"
									:delimited="widget.delimited"
								/>
						</div>
					</div>
					<vx-card >
            <div class="vx-row py-2 justify-between">
              <div class="vx-col">
                <div class="perPage">
                  <v-select
                    class="single-row-select"
                    v-model="tableMaxItems"
                    label=""
                    :searchable="false"
                    :options="[20,50,100]"
                  />
                </div>
              </div>

              <div
                :class="{ visible: isExcelFile }"
                class="vx-col download-btn"
              >
                <vs-custom-button
                  :disabled="!isExcelFile"
                  color="dark"
                  type="border"
                  class="vs-custom-button vs-button-text"
                  @click="downloadExcelFile(excelFile.file)"
                >
                  {{ $t("download") }}
                  
                  <feather-icon
                    svgClasses="h-5 w-5"
                    class="feather-icon"
                    icon="DownloadIcon"
                  />
                </vs-custom-button>
              </div>
            </div>

            <vs-table
              :max-items="tableMaxItems"
              pagination
              :data="table"
              class="table-th-center"
							:currentPage="currentTablePage"
							@change-page="setTablePageNumber"
            >
              <template slot="thead">
                <vs-th
                  v-for="fil in table_fields" class="justify-center text-center"
                  :sort-key="fil.field.split('.')[0]"
                >
                  {{ fil.title }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <template v-for="fil in table_fields">
                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-if="fil.field === 'order_id'">
                        <router-link :to="'ticket/' + tr.order_id">
                              № {{ tr.order_id }}
                        </router-link>
                    </vs-td>

                    <vs-td
                      v-else-if="fil.field === 'income'"
                      :class="{'text-center': fil.align && fil.align === 'center'}"
                      class="text-success"
                    >
                      {{ tr[fil.field] }}
                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'manager'">

                      {{tr[fil.field]}}
                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'website'">

                      {{tr[fil.field]}}

                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'date'">

                      {{tr[fil.field]}}

                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
                      ...
                    </vs-td>
                  </template>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
			</div>

      <div
				v-if="page === 3  && $store.getters.getRole ==='admin'"
				class="vx-row"
			>
          <div v-if="refundsPieChertData.series.length" class="vx-col w-full"
						 style="margin-bottom: 2.2rem;">
						<PieChartCard
              :chartOptions="chartOptions"
              :series="refundsPieChertData.series"
              :labels="refundsPieChertData.labels"
            />
					</div>
          <div class="vx-col w-full">
            <vx-card>
              <div class="vx-row mb-2 justify-between">
                <div class="vx-col">
                  <div class="perPage mb-2">
                    <v-select class="single-row-select"
                      v-model="maxRefunds"
                      label=""
                      :searchable="false"
                      :options="[20,50,100]"
                    />
                  </div>
                </div>
                
                <div class="vx-col download-btn" :class="{ visible: refundsExcelFile }">
                  <vs-custom-button
                    :disabled="!refundsExcelFile"
                    color="dark"
                    type="border"
                    class="vs-custom-button vs-button-text"
                    @click="downloadExcelFile(refundsExcelFile)"
                  >
                    {{ $t("download") }}
                    
                    <feather-icon
                      svgClasses="h-5 w-5"
                      class="feather-icon"
                      icon="DownloadIcon"
                    />
                  </vs-custom-button>
                </div>
              </div>
              <vs-table
                :max-items="maxRefunds"
                pagination
                :data="refundsTable"
                class="table-th-center"
                :currentPage="currentRefundsPage"
                @change-page="setRefundsPageNumber"
              >
                <template slot="thead">
                  <vs-th
                    v-for="fil in refundsTableFields" class="justify-center text-center"
                    :sort-key="fil.field.split('.')[0]"
                  >
                    {{ fil.title }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <template v-for="fil in refundsTableFields">

                      <vs-td
                        v-if="tr[fil.field]"
                        :class="{'text-center': fil.align && fil.align === 'center'}"
                      >
                        {{ tr[fil.field] }}
                      </vs-td>

                      <vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
                        ...
                      </vs-td>
                    </template>

                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
      </div>

      <div
				v-if="page === 4 && $store.getters.getRole ==='admin'"
				class="vx-row"
			>
					<div
					    class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
						style="margin-bottom: 2.2rem;"
					>
						<div class="vx-row">
              <div class="vx-col w-full">
                <statistics-card-line
                  v-for="(widget, idx) in penaltyWidgetsList"
                  :key="idx"
                  hideChart
                  class="mb-base"
                  icon-right
                  :icon="widget.icon"
                  :color="widget.color"
                  :statistic="widget.value"
                  :statisticTitle="widget.name"
                  :delimited="widget.delimited"
                />
              </div>
						</div>
					</div>
          <div v-if="penaltiesPieChertData.series.length" class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3"
						 style="margin-bottom: 2.2rem;">
						<PieChartCard
              :chartOptions="chartOptions"
              :series="penaltiesPieChertData.series"
              :labels="penaltiesPieChertData.labels"
            />
					</div>
      </div>
      
      <div
				v-if="page === 5  && $store.getters.getRole === 'admin'"
				class="vx-row"
			>
          <div v-if="failsPieChertData.series.length" class="vx-col w-full"
						 style="margin-bottom: 2.2rem;">
						<PieChartCard
              :chartOptions="chartOptions"
              :series="failsPieChertData.series"
              :labels="failsPieChertData.labels"
            />
					</div>
          <div class="vx-col w-full">
            <vx-card>
              <div class="vx-row mb-2 justify-between">
                <div class="vx-col">
                  <div class="perPage">
                    <v-select class="single-row-select"
                      v-model="maxFailsItems"
                      label=""
                      :searchable="false"
                      :options="[20,50,100]"
                    />
                  </div>
                </div>
                
                <div class="vx-col download-btn" :class="{ visible: failsExcelFile }">
                  <vs-custom-button
                    :disabled="!failsExcelFile"
                    color="dark"
                    type="border"
                    class="vs-custom-button vs-button-text"
                    @click="downloadExcelFile(failsExcelFile)"
                  >
                    {{ $t("download") }}

                    <feather-icon svgClasses="h-5 w-5" class="feather-icon" icon="DownloadIcon" />
                  </vs-custom-button>
                </div>
              </div>

              <vs-table
                :max-items="maxFailsItems"
                pagination
                :data="failsTable"
                class="table-th-center"
                :currentPage="currentFailsPage"
                @change-page="setFailsPageNumber"
              >
                <template slot="thead">
                  <vs-th
                    v-for="fil in failsTableFields" 
                    :sort-key="fil.field.split('.')[0]"
                    :key="fil.field"
                    class="justify-center text-center"
                  >
                    {{ fil.title }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <template v-for="fil in failsTableFields">

                      <vs-td
                        v-if="fil.field === 'order_id'"
                        :class="{'text-center': fil.align && fil.align === 'center'}"
                      >
                        <router-link :to="'ticket/' + tr.order_id">
                          {{ tr.order_id }}
                        </router-link>
                      </vs-td>

                      <vs-td
                        v-else-if="tr[fil.field]"
                        :class="{'text-center': fil.align && fil.align === 'center'}"
                      >
                        {{ tr[fil.field] }}
                      </vs-td>

                      <vs-td v-else :class="{'text-center': fil.align && fil.align === 'center'}">
                        ...
                      </vs-td>
                    </template>

                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
      </div>

      <div
				v-if="page === 6  && $store.getters.getRole ==='admin'"
				class="vx-row justify-end"
			>
        <div class="vx-col w-full">
          <vx-card >
            <div class="vx-row py-2 justify-between">
              <div class="vx-col">
                <div class="perPage">
                  <v-select
                    class="single-row-select"
                    v-model="tableMaxItems"
                    label=""
                    :searchable="false"
                    :options="[20,50,100]"
                  />
                </div>
              </div>
            </div>

            <vs-table
              :max-items="tableMaxItems"
              pagination
              :data="leedsTable"
              class="table-th-center"
              :currentPage="currentLeedsPage"
              @change-page="setLeedsTablePageNumber"
            >
              <template slot="thead">
                <vs-th
                  v-for="fil in table_fields" class="justify-center text-center"
                  :sort-key="fil.field.split('.')[0]"
                >
                  {{ fil.title }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <template v-for="fil in table_fields">
                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-if="fil.field === 'order_id'">
                        <router-link :to="'ticket/' + tr.order_id">
                              № {{ tr.order_id }}
                        </router-link>
                    </vs-td>

                    <vs-td
                      v-else-if="fil.field === 'income'"
                      :class="{'text-center': fil.align && fil.align === 'center'}"
                      class="text-success"
                    >
                      {{ tr[fil.field] }}
                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'manager'">

                      {{tr[fil.field]}}
                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'website'">

                      {{tr[fil.field]}}

                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
                        v-else-if="fil.field === 'date'">

                      {{tr[fil.field]}}

                    </vs-td>

                    <vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
                      ...
                    </vs-td>
                  </template>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
			</div>

      <template v-if="page === 7 && $store.getters.getRole ==='admin'">
        <AnswerTimeStatsComponent
          :table="answerTimeTable"
          :currentPage.sync="currentAnswerTimePage"
          :widgets="answerTimeWidgets"
          :chartOptions="adminReplyTypesGraphs"
        />
      </template>
		</div>
	</div>
</template>

<script>
import notifier from "@/mixins/notifier";
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import PieChartCard from "@/components/statistics-cards/PieChartCard";
import databaseManager from "@/mixins/databaseManager";
import VSelect from 'vue-select'
import moment from 'moment'
import VsDatepickerRange from "@/components/vs-datepicker/VsDatepickerRange";
import getChartOptions from '@/views/Stats/stats-utils/chart-options'
import getTableFields from '@/views/Stats/stats-utils/tables/table-fields'
import getRefundsTaleFields from '@/views/Stats/stats-utils/tables/refunds-table-fields'
import getFailsTableFields from '@/views/Stats/stats-utils/tables/fails-table-fields'
import AnswerTimeStatsComponent from '@/views/Stats/components/AnswerTimeStatsComponent.vue'
import SitesStatsComponent from '@/views/Stats/components/SitesStatsComponent.vue'
import StatsButtonTabs from '@/views/Stats/components/StatsButtonTabs.vue'
import getFailsWidgets from '@/views/Stats/stats-utils/widgets/fails-widgets'
import getManagersWidgets from '@/views/Stats/stats-utils/widgets/managers-widgets'
import getRefundsWidgets from '@/views/Stats/stats-utils/widgets/refunds-widgets'
import getPenaltiesWidgets from '@/views/Stats/stats-utils/widgets/penalties-widgets'
import getAnswerTimeWidgets from '@/views/Stats/stats-utils/widgets/answer-time-widgets'
import getAdminStats from '@/views/Stats/stats-utils/widgets/admin-widgets'
import getAuthorStats from '@/views/Stats/stats-utils/widgets/author-widgets'
import getManagerStats from '@/views/Stats/stats-utils/widgets/manager-widgets'
import getLeadsWidgets from '@/views/Stats/stats-utils/widgets/leads-widgets'
import getPeriods from '@/views/Stats/stats-utils/periods'

export default {
	mixins: [databaseManager, notifier],
	components: {
    VsDatepickerRange,
    StatisticsCardLine,
    PieChartCard,
    VSelect,
    AnswerTimeStatsComponent,
    StatsButtonTabs,
    SitesStatsComponent,
},
	data () {
		return {
			page: 0,
			selectedManager: null,
			selectedManagers: [],
			selectedReplyTypes: [],
			selectedSites: [],
			selectedReasons: [],
			period: [moment().locale('de').subtract(1, 'days').toDate(), moment().locale('de').endOf('day').toDate()],
			from: moment().locale('de').subtract(1, 'days').format('YYYY-MM-DD'),
			to: moment().locale('de').endOf('day').format('YYYY-MM-DD'),
			managers: [],
			sites: [],
			reasons: [],
			replyTypes: [],
			periods: getPeriods(this),
			widgets: [],
			widgetManagers: getManagersWidgets(this),
      widgetRefunds: getRefundsWidgets(this),
      widgetFails: getFailsWidgets(this),
      widgetPenalties: getPenaltiesWidgets(this),
			charts: [],
			adminGraphOrders: null,
			manager: getManagerStats(this),
			author: getAuthorStats(this),
			admin: getAdminStats(this),
			chartOptions: getChartOptions(),
			table: [],
      tableMaxItems: 20,
      currentTablePage: 1,
			table_fields: getTableFields(this),
      refundsTable: [],
      maxRefunds: 20,
      currentRefundsPage: 1,
      refundsTableFields: getRefundsTaleFields(this),
			work_types: [],
			subjects: [],

      failsTable: [],
      currentFailsPage: 1,
      maxFailsItems: 20,
      failsTableFields: getFailsTableFields(this),

      answerTimeTable: [],
      currentAnswerTimePage: 1,
			answerTimeWidgets: getAnswerTimeWidgets(this),

      leedsTable: [],
      widgetLeads: getLeadsWidgets(this),
      currentLeedsPage: 1,
      hideSpam: true,

      excelFile: null,
      failsExcelFile: null,
      refundsExcelFile: null,

      isLoading: false,
		}
	},
	watch: {
		selectedManagers (newVal, oldVal) {
			if (oldVal !== newVal) {
				this.fetchManagersStats()
				this.getManagersPaidStats()
        
        if (this.page == 3) {
          this.fetchRefundsStats()
        } else if (this.page == 5) {
          this.fetchFailsStats()
        } else if (this.page == 6) {
          this.getLeedsStats()
        } else if (this.page == 7) {
          this.getAnswersTimeStats()
        }
			}
		},

		selectedReplyTypes(newVal, oldVal) {
			if (oldVal !== newVal) {
				this.getAnswersTimeStats()
			}
		},

		async selectedSites (newVal, oldVal) {
			if (oldVal !== newVal) {
        if (this.page === 2) {
          await this.fetchManagersStats()
          await this.getManagersPaidStats()
        } else if (this.page == 3) {
          await this.fetchRefundsStats()
        } else if (this.page == 5) {
          await this.fetchFailsStats()
        } else if (this.page == 6) {
          await this.getLeedsStats()
        } else if (this.page == 7) {
          await this.getAnswersTimeStats()
        }
			}
		},

    selectedReasons(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.fetchRefundsStats()

        if (this.page == 3) {
          this.fetchRefundsStats()
        } else if (this.page == 5) {
          this.fetchFailsStats()
        }
      }
		},

		selectedManager (newVal, oldVal) {
			if (oldVal !== newVal) {
				this.fetchStats()
			}
		},

		async page(newVal, oldVal) {
			this.chartOptions.xaxis.categories = []
      if (newVal === 2) {
        await this.fetchManagersStats()
        await this.getManagersPaidStats()
      } else if (newVal === 3) {
        this.reasons = await this.dbGetReturnReasons()
        await this.fetchRefundsStats()
      } else if (newVal === 4) {
        this.fetchPenaltiesStats()
      } else if (newVal === 5) {
        this.reasons = await this.dbGetFailsReasons()
        await this.fetchFailsStats()
      } else if (newVal === 6) {
        await this.getLeedsStats()
      } else if (this.page == 7) {
        await this.getAnswersTimeStats()
        this.replyTypes = await this.dbGetReplyTypes()
        this.selectAllReplyTypes()
      } else {
        await this.fetchStats()
      }

      this.selectAllReasons()
      this.selectAllSites()
      this.selectAllManagers()
		},
		period (newVal, oldVal) {
			if (oldVal !== newVal) {

				if(newVal && newVal[0])	this.from = moment(newVal[0]).format('YYYY-MM-DD');
				else 					this.from = null

				if(newVal && newVal[1]) this.to = moment(newVal[1]).format('YYYY-MM-DD');
				else 					this.to = null;


				if(this.page == 2) {
					this.fetchManagersStats()
					this.getManagersPaidStats()
				} else if (this.page == 3) {
          this.fetchRefundsStats()
        } else if (this.page == 4) {
          this.fetchPenaltiesStats()
        } else if (this.page == 5) {
          this.fetchFailsStats()
        } else if (this.page === 6) {
          this.getLeedsStats()
        } else if (this.page === 7) {
          this.getAnswersTimeStats()
        } else {
					this.fetchStats();
				}

        this.clearTablePages()
			}
		},
    maxRefunds() {
      this.currentRefundsPage = 1
    },
    tableMaxItems() {
      this.currentTablePage = 1
    },
	},
	computed: {
    showReasonsSelect() {
      const match = [3, 5].indexOf(this.page)
      return (match !== -1) && this.$store.getters.getRole === 'admin'
    },
    
    showSitesSelect() {
      const match = [1, 2, 3, 5, 6, 7].indexOf(this.page)
      return (match !== -1) && this.$store.getters.getRole === 'admin'
    },
    
    showManagersSelect() {
      const match = [2, 3, 5, 6, 7].indexOf(this.page)
      return (match !== -1) && this.$store.getters.getRole === 'admin'
    },

    reasonsSelectPlaceholder() {
      if (this.page === 3) {
        return this.$t('refundReasons')
      } else if (this.page === 5) {
        return this.$t('failsReasons')
      }

      return '...'
    },

    failsPieChertData() {
      let series = []
      let labels = []
      if (this.widgetFails.data && this.widgetFails.data.order_fail_reason.length) {
        const widgetData = this.widgetFails.data && this.widgetFails.data.count ? this.widgetFails.data.order_fail_reason : [{ count: 1, name: ' ' }]
        series = widgetData.map(el => el.count)
        labels = widgetData.map(el => el.name)
      }
      return {
        series,
        labels
      }
    },

    refundsPieChertData() {
      let series = []
      let labels = []
      if (this.widgetRefunds.data && this.widgetRefunds.data.order_return_reason.length) {
        const widgetData = this.widgetRefunds.data && this.widgetRefunds.data.count ? this.widgetRefunds.data.order_return_reason : [{count: 1, name: ' '}]
        series = widgetData.map(el => el.count)
        labels = widgetData.map(el => el.name)
      }
      return {
        series,
        labels
      }
    },

    penaltiesPieChertData() {
      let series = []
      let labels = []
      if (this.widgetPenalties.data && this.widgetPenalties.data.order_penalties_reason) {
        const widgetData = this.widgetPenalties.data ? this.widgetPenalties.data.order_penalties_reason : []
        series = widgetData.map(el => el.count)
        labels = widgetData.map(el => el.name)
      }
      return {
        series,
        labels
      }
    },

		currentMultiWidgets() {
			return this.widgets.filter(widget => widget.type === "multiWidget");
		},

		managersRightWidgets(){

			return this.widgetManagers.rightWidgets.map( widget => {

				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				}
			});
		},

		refundsRightWidgets(){

			return this.widgetRefunds.rightWidgets.map( widget => {

				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				}
			});
		},

		failsRightWidgets(){

			return this.widgetFails.rightWidgets.map( widget => {

				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				}
			});
		},

		penaltyWidgetsList(){
			return this.widgetPenalties.widgets.map( widget => {

				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				}
			});
		},

		leadsWidgetsList(){
			return this.widgetLeads.widgets.map( widget => {

				const value = widget.data ? widget.data.value : 0;

				return {
					code: widget.code,
					name: widget.name,
					value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
					icon: widget.icon,
					color: widget.color,
					delimited: widget.delimited
				}
			});
		},

		currentWidgets () {
			return this.widgets
				.filter(widget => widget.type === 'widget')
				.map(widget => {
					let val

					if (widget.data.hasOwnProperty('value')) 				val = widget.data.value;
					else if (widget.data.hasOwnProperty('amount')) 			val = widget.data.amount;
					else if (widget.data.hasOwnProperty('count')) 			val = widget.data.count;
					else if (widget.data.hasOwnProperty('count_sites'))		val = widget.data.count_sites;

					let count_fail = widget.data.count_fail;
					let count_success = widget.data.count_success;
					let success_widget_data = null;

					if (isFinite(count_fail) && isFinite(count_success)) success_widget_data = count_success + '/' + count_fail;

					const value = success_widget_data || val;

					return {
						code: widget.code,
						name: widget.name,
						value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
						icon: widget.icon,
						color: widget.color,
						delimited: widget.delimited
					}
				});
		},
		currentGraphs () {
			return this.widgets.filter(widget => widget.type === 'chart').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions))

				let series = []

				if (widget.multiple_series) {
					for (const key in widget.data) {
						let serie = {
							name: 'serie',
							data: []
						}
						widget.data[key].forEach(({x, y, date}) => {
							this.filterDataCategories(chartOptions, date)
							chartOptions.xaxis.categories.push(date)
							serie.data.push(y)
						})

						if(isNaN(+key)) {
							if(key === 'income') {
								serie.name = this.$t(`stats.${key + "Clean"}`)
							} else if (key === 'active') {
								serie.name = this.$t(`stats.active`)
							} else if (key === 'completed') {
								serie.name = this.$t(`stats.completeOrder`)
							} else {
								serie.name = this.$t(`stats.incomeTotal`)
							}
						} else {
							serie.name = key;
						}
						series.push(serie);
					}
				} else {
					let serie = {
						name: 'serie',
						data: []
					}
					widget.data.forEach(({x, y, date}) => {
						this.filterDataCategories(chartOptions, date)

						chartOptions.xaxis.categories.push(date)
						serie.data.push(y)

					});
					serie.name = widget.lineName || "11";
					series.push(serie)
				}

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					chartOptions
				}
			})
		},
		adminCurrentPieGraphs() {
			return this.widgets.filter(item => item.type === 'pie').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions));

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series: widget.data.series,
					labels: widget.data.labels,
					chartOptions
				}
			});
		},
		adminCurrentManagerGraphs() {
			let series = [];
			let chartOptions = JSON.parse(JSON.stringify(this.chartOptions))


			for (let key in this.widgetManagers.data) {
				let serie = {
					name: 'serie',
					data: []
				}
				this.widgetManagers.data[key].forEach(({x, y, date}) => {
					this.filterDataCategories(chartOptions, date)
					chartOptions.xaxis.categories.push(date)
					serie.data.push(y)
				})

				serie.name = key;

				series.push(serie);
			}
			if(series.length === 0){
				chartOptions.legend.show = false;
			}
			return {
				name: this.widgetManagers.name,
				series,
				chartOptions
			}
		},

		adminReplyTypesGraphs() {
			let series = [];

			let options = { 
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: undefined,
          },
          type: "category",
        },
        legend: {
          show: true,
          showForSingleSeries: true,
        }
      }
      

			for (let key in this.answerTimeWidgets.data) {
        
				let serie = {
					name: 'serie',
					data: []
				}
				this.answerTimeWidgets.data[key].forEach(({x, y}) => {
          serie.data.push(y)
				})
        if (key === 'Первое сообщение') {
          serie.color = "#7367F0"
        } else if (key === 'Поддержка') {
          serie.color = "#FF9F43"
        } else if (key === 'Продажа') {
          serie.color = "#28C76F"
        }

				serie.name = key;

				series.push(serie);
			}

      const firsKey = series.length ? series[0].name : ''
      const categoriesArr = this.answerTimeWidgets.data[firsKey] || []

      options.xaxis.categories = categoriesArr.map((el) => el.x)

      options.xaxis.labels.formatter = (date) => {
        if (typeof date === 'string') {
          return this.filterDataXAxisLabels(date)
        }

        return ''
      }
      
			if(series.length === 0){
				options.legend.show = false;
			}
			return {
				series,
				options
			}
		},

		adminCurrentSitesGraphs() {
			return this.widgets.filter(widget => widget.type === 'siteChart').map(widget => {

				let series = [];
				let manager = [];
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions));
				let chartOptionsManager = JSON.parse(JSON.stringify(this.chartOptions));

				['data', 'manager'].forEach( option => {



					if(widget[option]){
						for (let key in widget[option]) {
							let serie = {
								name: 'serie',
								data: []
							}
							widget[option][key].forEach(({x, y, date}) => {
								if(option === 'manager'){
									this.filterDataCategories(chartOptionsManager, date)
									chartOptionsManager.xaxis.categories.push(date)
								}else{
									this.filterDataCategories(chartOptions, date)
									chartOptions.xaxis.categories.push(date)
								}
								serie.data.push(y)
							})

							if (isNaN(+key)) {
								if (key === 'income') {
									serie.name = this.$t(`stats.${key + "Clean"}`)
								} else {
									serie.name = this.$t(`stats.incomeTotal`)
								}
							} else {
								serie.name = key;
							}
							if (option === 'data') {
								series.push(serie);
							} else {
								manager.push(serie);
							}

						}
					}

				})

				if(manager.length === 0){
					chartOptionsManager.legend.show = false;
				}

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					manager,
					chartOptions,
					chartOptionsManager
				}
			})
		},
		adminCurrentGraphs () {
			return this.widgets.filter(widget => widget.type === 'chart').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions));

				let series = []

				if (widget.multiple_series) {
					for (let key in widget.data) {
						let serie = {
							name: 'serie',
							data: []
						}
						widget.data[key].forEach(({x, y, date, total}) => {

							this.filterDataCategories(chartOptions, date)

							chartOptions.xaxis.categories.push(date)
							// serie.data.push([date, y, total]);
							serie.data.push(y);

						})


						if(widget.code === "graphSubjects") {
							serie.name = this.$getDeep(+key, this.subjects);
						} else if(isNaN(+key)) {
							if(key === 'income') {
								serie.name = this.$t(`stats.${key + "Clean"}`)
							} else if(key === 'total') {
								serie.name = this.$t(`stats.incomeTotal`)
							}else{
								serie.name = this.$t(`stats.${key}`) ;
							}
						} else {
							serie.name = key;
						}

						series.push(serie);
					}
				} else {
					let serie = {
						name: 'serie',
						data: []
					}
					widget.data.forEach(({x, y, date}) => {
						this.filterDataCategories(chartOptions, date)

						chartOptions.xaxis.categories.push(date)
						serie.data.push(y)

					})

					serie.name = '11'
					series.push(serie)
				}

				chartOptions.tooltips.z.formatter = (val) => {
					return val
				}
				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					chartOptions
				}
			})
		},
		adminPaidNewTickets () {
			const widget = this.adminGraphOrders

			for (const key in widget.data) {
				let serie = {
					name: 'serie',
					data: []
				}
				widget.data[key].forEach(({x, y, date}) => {
					this.filterDataCategories(chartOptions, date)
					chartOptions.xaxis.categories.push(date)
					serie.data.push(y)
				})
				serie.name = key
				series.push(serie)
			}
		},
    isExcelFile() {
      return this.excelFile ? this.excelFile.file : null
    }

	},
	methods: {
    async onHideSpamChange() {
      await this.getLeedsStats()
    },

    clearTablePages() {
      this.currentAnswerTimePage = 1
      this.currentTablePage = 1
      this.currentRefundsPage = 1
      this.currentFailsPage = 1
      this.currentLeedsPage = 1
    },

    setFailsPageNumber(data) {
			this.currentFailsPage = data;
    },

    setRefundsPageNumber(data) {
			this.currentRefundsPage = data;
    },

    setTablePageNumber(data) {
			this.currentTablePage = data;
    },

    setLeedsTablePageNumber(data) {
			this.currentLeedsPage = data;
    },

		filterDataCategories(opts, date) {
			let sum = new Date(this.to).getTime() - new Date(this.from).getTime()
			sum = parseInt((sum)/(24*3600*1000));
			if (sum <= 1) {
				return opts.xaxis.labels.formatter = undefined
			}else if (sum <= 31) {
				return opts.xaxis.labels.formatter = (date) => {
          const label = new Date(date).toLocaleDateString('de', { month: 'short', day: 'numeric' })
          return label
				}
			} else {
        return opts.xaxis.labels.formatter = (date) => {
					return moment(new Date(date)).locale('de').format("MMM YYYY")
				}
			}
		},

		filterDataXAxisLabels(date) {
			let sum = new Date(this.to).getTime() - new Date(this.from).getTime()
			sum = parseInt((sum)/(24*3600*1000));

      if (!this.to || !this.from) {
        return ''
      }
			if (sum => 0 && sum <= 31) {
        const label = new Date(date).toLocaleDateString('de', { month: 'short', day: 'numeric' })
        return label
			} else {
        return moment(new Date(date)).locale('de').format("MMM YYYY")
			}
		},

		async fetchManagersStats() {
      const isManagers = this.selectedManagers && this.selectedManagers.length
      const isWebsites = this.selectedSites && this.selectedSites.length

      try {
        if(!isManagers || !this.from  || !this.to || !isWebsites){
          let rightWidgets = this.widgetManagers.rightWidgets.map( d => {
            d.data = null
            return d
          });
          this.widgetManagers.data = [];
          this.widgetManagers.rightWidgets = rightWidgets;
          this.excelFile = null
        }
        else{
          const sitesArr = this.selectedSites || []

				  let sites = sitesArr.map((el) => el.id);
          let managers = this.selectedManagers.map(d => d.user_id);

          let data = await this.dbGetManagersGraph(managers, this.from, this.to, sites);
          let numberOfPayments = await this.dbGetManagersNumberOfPayments(managers, this.from, this.to, sites);
          let sumOfPayments = await this.dbGetManagersSumOfPayments(managers, this.from, this.to, sites);
          this.excelFile = await this.dbGetStatsExcelFile(managers, this.from, this.to, sites)


          let rightWidgets = this.widgetManagers.rightWidgets.map( d => {
            if(d.type === 'numberOfPayments'){
              d.data = numberOfPayments
            }else if (d.type === 'sumOfPayments') {
              d.data = sumOfPayments
            }
            return d
          });


          this.widgetManagers = { ...this.widgetManagers,
            data,
            rightWidgets
          };
        }
      } catch (e) {
				this.notifyError(e.message)
      }

		},

		async fetchRefundsStats() {

			if(!(this.selectedManagers && this.selectedManagers.length)
      || !(this.selectedSites && this.selectedSites.length)
      || !(this.selectedReasons && this.selectedReasons.length)
      || !this.from  || !this.to ){
				let rightWidgets = this.widgetRefunds.rightWidgets.map( d => {
					d.data = null
					return d
				});
				this.widgetRefunds.data = null;
				this.widgetRefunds.rightWidgets = rightWidgets;
        this.refundsTable = []
        this.refundsExcelFile = null
			}
			else{

        const managersArr = this.selectedManagers || []
        const sitesArr = this.selectedSites || []
        const reasonsArr = this.selectedReasons || []

				let managers = managersArr.map(d => d.user_id);
				let sites = sitesArr.map(d => d.id);
				let reasons = reasonsArr.map(d => d.id);

				const refundsRate = await this.dbGetRefundsRate({managers, from: this.from, to: this.to, sites, reasons});

				const tableRes = await this.dbGetRefundsTable({managers, from: this.from, to: this.to, sites, reasons});
        this.refundsTable = tableRes.data

				const refundsCount = await this.dbGetRefundsCount({managers, from: this.from, to: this.to, sites, reasons});

				const refundsSum = await this.dbGetRefundsSum({managers, from: this.from, to: this.to, sites, reasons});

				const fileRes = await this.dbGetRefundsTable({managers, from: this.from, to: this.to, sites, reasons}, true);
        this.refundsExcelFile = fileRes.file


				let rightWidgets = this.widgetRefunds.rightWidgets.map( d => {
					if(d.type === 'numberOfRefunds'){
						d.data = refundsCount.data
					}else if (d.type === 'sumOfRefunds') {
						d.data = refundsSum.data
            d.color = 'danger'
            d.symbol = ' €'
					}
					return d
				});


				this.widgetRefunds = { ...this.widgetRefunds,
					data: refundsRate.data,
					rightWidgets
				};
			}
		},

    async fetchFailsStats() {
      if (!(this.selectedManagers && this.selectedManagers.length)
        || !(this.selectedSites && this.selectedSites.length)
        || !(this.selectedReasons && this.selectedReasons.length)
        || !this.from || !this.to) {
        let rightWidgets = this.widgetFails.rightWidgets.map(d => {
          d.data = null
          return d
        })
        this.widgetFails.data = null
        this.widgetFails.rightWidgets = rightWidgets
        this.failsExcelFile = null
        this.failsTable = []
      } else {

        const managersArr = this.selectedManagers || []
        const sitesArr = this.selectedSites || []
        const reasonsArr = this.selectedReasons || []

        let managers = managersArr.map(d => d.user_id)
        let sites = sitesArr.map(d => d.id)
        let reasons = reasonsArr.map(d => d.id)

        const rateRes = await this.dbGetFailsRate({ managers, from: this.from, to: this.to, sites, reasons })

        const tableRes = await this.dbGetFailsTable({ managers, from: this.from, to: this.to, sites, reasons })
        this.failsTable = tableRes.data

        const sumRes = await this.dbGetFailsSum({ managers, from: this.from, to: this.to, sites, reasons })

        const fileRes = await this.dbGetFailsTable({ managers, from: this.from, to: this.to, sites, reasons } , true)
        this.failsExcelFile = fileRes.file


        const rightWidgets = this.widgetFails.rightWidgets.map(d => {
          if (d.type === 'numberOfFails') {
            d.data = sumRes.data
          }
          return d
        })


        this.widgetFails = {
          ...this.widgetFails,
          data: rateRes.data,
          rightWidgets
        }
      }
    },

		async fetchPenaltiesStats(){
      try {
        if(!this.from  || !this.to ){
          let widgets = this.widgetPenalties.widgets.map( d => {
            d.data = null
            return d
          });
          this.widgetPenalties.data = null;
          this.widgetPenalties.widgets = widgets
        }
        else{

          let data = await this.dbGetPenaltiesRate(this.from, this.to);
          let numberOfPenalties = await this.dbGetPenaltiesCount(this.from, this.to);
          let sumOfPenalties = await this.dbGetPenaltiesSum(this.from, this.to);


          let widgets = this.widgetPenalties.widgets.map( d => {
            if(d.type === 'numberOfPenalties'){
              d.data = numberOfPenalties
            }else if (d.type === 'sumOfPenalties') {
              d.data = sumOfPenalties
              d.color = 'danger'
              d.symbol = ' €'
            }
            return d
          });


          this.widgetPenalties = { ...this.widgetPenalties,
            data,
            widgets
          };
        }
      } catch (e) {
				this.notifyError(e.message)
      }
		},
		async fetchStats () {
			let role = this.$store.getters.getRole
			const requests = this[role].widgets.map(async (widget) => {
				if(widget.type !== 'multiWidget') {
					let data, object;
					if(widget.type !== 'widget') {
						data = await this.dbGetGraph(widget.url, this.from, this.to);
					} else {
						data = await this.dbGetGraph(widget.url);
					}

					object = {
						...widget,
						data
					};

					if(widget.type === 'siteChart' && this.selectedManager){
						object.manager = await this.dbGetGraph(widget.url, this.from, this.to, this.selectedManager);
					}

					return object;
				} else {
					let newWidget = {
						type: "multiWidget",
						widgets: [],
					};

					for(let sub of widget.widgets) {
						let data = await this.dbGetGraph(sub.url);
						let value = null;

						if(data.count) value = data.count;
						else if(data.value) value = data.value;
						else if(data.conversion) value = data.conversion;

						value = value || 0;

						newWidget.widgets.push({
							statistic: sub.symbol !== undefined ? `${value}${sub.symbol}` : value,
							statisticTitle: sub.name,
							icon: sub.icon,
							color: sub.color
						});
					}

					return newWidget;
				}
			})

			let new_widgets = []
			if (this.$store.getters.isAdmin) {
				try {
					const {
						completed,
						conversion,
						failed,
						new: graph_new,
						paid
					} = (await this.dbGetGraph("/stats/get-graph-orders", this.from, this.to))
					new_widgets.push({
						code: 'admin_new_paid_tickets',
						name: this.$t('stats.newPaidTickets'),
						data: {
							graph_new,
							paid
						},
						type: 'chart',
						multiple_series: true
					});
					new_widgets.push({
						name: this.$t('stats.completedTickets'),
						data: {
							completed,
							failed
						},
						type: 'chart',
						multiple_series: true
					});
					new_widgets.push({
						name: this.$t('stats.conversion'),
						data: {conversion},
						type: 'chart',
						multiple_series: true
					});

					const failReasonsResponse = (await this.dbGetGraph("/stats/get-success-rate", this.from, this.to));
					const failReasons = failReasonsResponse.order_fail_reason;

					if(failReasons.length > 0) {
						new_widgets.push({
							code: 'admin_fail_reasons',
							data: {
								series: failReasons.map(item => item.count),
								labels: failReasons.map(item => item.name)
							},
							type: 'pie',
						});
					}

				} catch(e) {
					console.log(e)
				}
			}
			new_widgets = [...new_widgets, ...(await Promise.all(requests))];
			this.widgets = new_widgets;

			// if(!this.$store.getters.isAdmin){
			// 	this.table = this.dbGetPaidOrders(this.from, this.to);
			// }
		},

		async getManagersPaidStats() {
      const managersArr = this.selectedManagers || []
			let managers = managersArr.map(d => d.user_id) || null;
      const isWebsites = this.selectedSites && this.selectedSites.length

      if (!managersArr.length || !isWebsites) {
        this.table = []
      } else {
        try {
          const sitesArr = this.selectedSites.map((el) => el.id) || []

          const res = await this.dbGetManagersPaidOrders(this.from, this.to, managers, sitesArr)
  
          res.forEach(el => {
            el.income = +el.income
            return el;
          })
  
          this.table = res
        } catch (e) {
          this.notifyError(e.message);
        }
      }

		},

		async getLeedsStats() {
      const managersArr = this.selectedManagers || []
			let managers = managersArr.map(d => d.user_id) || null;
      const isWebsites = this.selectedSites && this.selectedSites.length

      if (!managersArr.length || !isWebsites || !this.from  || !this.to) {
        this.leedsTable = []
        let widgets = this.widgetLeads.widgets.map( d => {
          d.data = null
          return d
        });
        this.widgetLeads.data = null;
        this.widgetLeads.widgets = widgets
      } else {
        try {
          this.isLoading = true
          const sitesArr = this.selectedSites.map((el) => el.id) || []

          const requestBody = {
            from: this.from,
            to: this.to,
            sites: sitesArr,
            hideSpam: this.hideSpam,
            managers,
          }

          const tableRes = await this.dbGetLeadsTable(requestBody)

          const foo = {
            conversionPercent: await this.dbGetLeadsConversionPercent(requestBody),
            totalLeadsByPeriod: await this.dbGetLeadsNumber(requestBody),
            totalPayedLeadsByPeriod: await this.dbGetPaidLeadsNumber(requestBody),
          }

          
          let widgets = this.widgetLeads.widgets.map( d => {
            if (foo[d.type]) {
              d.data = foo[d.type]
            }
            return d
          });


          this.widgetLeads = { 
            ...this.widgetLeads,
            widgets
          };
  
          this.leedsTable = tableRes
        } catch (e) {
          this.notifyError(e.message);
        } finally {
          this.isLoading = false
        }
      }

		},

    async getAnswersTimeStats() {
      const managersArr = this.selectedManagers || []
      const sitesArr = this.selectedSites || []
      const repliesArr = this.selectedReplyTypes || []

			const replies = repliesArr.map(el => el.id)
			const managers = managersArr.map(m => m.user_id)
      const sites = sitesArr.map((el) => el.id)

      const body = {
        from: this.from,
        to: this.to, 
        sites,
        managers,
        replies,
      }
      
      if (
        !sites.length ||
        !managers.length ||
        !replies.length ||
        !this.from  ||
        !this.to
      ) {
        this.answerTimeTable = []
        let widgets = this.answerTimeWidgets.widgets.map( d => {
          d.data = null
          return d
        });
        this.answerTimeWidgets.data = []
        this.answerTimeWidgets.widgets = widgets
      } else {
          await Promise.all([
            this.getAnswersTimeTableStats(body),
            this.getAnswersTimeWidgetStats(body),
          ])
      }
    },

		async getAnswersTimeTableStats(data) {
      try {
        const res = await this.dbGetAnswersTimeTable(data)
        this.answerTimeTable = res
      } catch (e) {
        this.notifyError(e.message);
      }
		},

		async getAnswersTimeWidgetStats(data) {
      const isManagers = this.selectedManagers && this.selectedManagers.length
      const isWebsites = this.selectedSites && this.selectedSites.length

      try {
        const res = await this.dbGetAnswersTimeWidget(data)
        const graphData = await this.dbGetAnswersTimeGraph(data)

        let widgets = this.answerTimeWidgets.widgets.map( d => {
          if(d.type === 'answersTime'){
            d.data = res.value
          }
          return d
        });


        this.answerTimeWidgets = {
          ...this.answerTimeWidgets,
          widgets,
          data: graphData,
        }
      } catch (e) {
        this.notifyError(e.message);
      }
		},

		async getWorks () {
			try {
				this.work_types = (
					await this.$http.get(`/settings/get-work-types`)).data.data
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		},
		async getSubjects () {
			try {
				this.subjects = (
					await this.$http.get(`/settings/get-subjects`)).data.data
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		},
		async addSitesIncome() {
			this.sites = await this.dbGetWebSites();
      this.selectAllSites()

			for(let site of this.sites) {
				const websiteFilter = `filter[site_id]=${site.id}`;
				this.admin.widgets.push({
					code: `graphSiteIncome${site.id}`,
					name: site.name,
					url: `/stats/get-graph-income?${websiteFilter}`,
					type: 'siteChart',
					multiple_series: true
				});
			}
		},
		async updateData() {
			try {
				if (!this.$store.getters.isAdmin){
					await this.getWorks()
				} else {
					await this.addSitesIncome();
				}

				await this.getSubjects();

				await this.fetchStats();

				await this.getManagersPaidStats();

			} catch(e) {
				this.notifyError(e.message);
			}
		},
		cleanSelectedManagers(){
			this.selectedManagers = []
			this.table = []
			this.refundsTable = []
		},
		cleanSelectedReplyTypes(){
			this.selectedReplyTypes = []
			this.answerTimeTable = []
		},
		cleanSelectedSites(){
			this.selectedSites = []
			this.refundsTable = []
		},
		cleanSelectedReasons(){
			this.selectedReasons = []
			this.refundsTable = []
		},
		selectAllManagers(){
			this.selectedManagers = this.managers;
		},
		selectAllReplyTypes(){
			this.selectedReplyTypes = this.replyTypes
		},
		selectAllSites(){
			this.selectedSites = this.sites;
		},
		selectAllReasons(){
			this.selectedReasons = this.reasons;
		},

		async getManagers(){
			if (this.$store.getters.getRole === 'admin') {
				try {
					let managers = (await this.$http.get(`admin/manager`)).data.data;
					this.managers = managers.map(d => ({
						name: d.first_name + ' ' + d.last_name,
						user_id: d.user_id
					}))
					this.selectAllManagers();
				} catch (e) {
					this.$vs.notify({
						title: 'Error',
						text: e.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger'
					})
				}
			}
		},

    async downloadExcelFile(file) {
      if (!file) {
        return
      }

      try {
        this.isDisabled = true;
        const link = document.createElement("a");
        link.href = file;
        link.setAttribute("download", "file.zip");
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          this.isDisabled = false;
        }, 2000);
      } catch (e) {
        this.notifyError(e.message);
      }
		},
	},
	async created () {
		await this.getManagers();
		await this.updateData();
	}
}
</script>
<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.statistics-page {
	.mx-datepicker-range{
		width: 100%;
	}
	.page-switch-button {
		border: $primary 1px solid;
	}

	&__widgets-col {
		@media screen and (min-width: 1500px) {
			width: 50% !important;
		}
	}

	.table-th-center {
		.vs-table-text {
			justify-content: center;
		}
	}

	.vs-table {
		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

  .perPage {
    width: 70px;
    flex: 0 0 auto;

    .vs__dropdown-toggle {
      border-radius: 100px;
    }

    .vs__clear {
      display: none;
    }
	  .vs__selected-options {
		  padding-left: 13px;
		  .vs__selected {
			  padding: 0;
			  flex: 0 0 auto;
			  padding: 0;
		  }
	  }

    .vs__search {
      padding: 0;
    }

    .v-select__selection {
      width: 100%;
      justify-content: center;
    }
  }

  .download-btn {
    transition: opacity ease 0.3s;
    opacity: 0.4;

    .vs-button--text {
      display: flex;
      align-items: center;
      grid-column-gap: 5px;
    }

    &.visible {
      opacity: 1;
    }
  }

  .refunds-widgets {
    width: 75%;
    @media screen and (max-width: 1200px) {
			width: 100%;
		}
  }

  .fails-widgets {
    width: 75%;
    @media screen and (max-width: 1200px) {
			width: 100%;
		}
  }
}

</style>
